export const AgentOfficeMessages = {
	ariseBoardingSuccess: (agentOfficeName: string) =>
		`Success! ${agentOfficeName || "Agent Office"} is boarded to ARISE`,
};
